import React, {useState, useRef, useEffect} from 'react';
import axios from 'axios';
import Box from "@mui/material/Box";
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import IconButton from "@mui/material/IconButton";
import { url } from '../../../Config';

export default function Change_in_software(props) {

    const date1Ref = useRef(null);
    const nameRef = useRef(null);
    const detailRef = useRef(null);
    const date2Ref = useRef(null);
    const optionRef = useRef(null);
    const btnRef = useRef(null);


    const [alertopen, setalertOpen] = useState(false);
    const [alertType, setalertType] = useState();
    const [AlertMessage, setalertmessage] = useState();


    const submitForm = async (event)=>{
        event.preventDefault();
        setalertOpen(false);

        if(optionRef.current.value == ''){
            setalertType("error");
            setalertOpen(true);
            setalertmessage('Please Select An Option from "Changes Made In" field');
            return;
        }

        const res = await axios.post(`${url}/api/storeMitPolicy`, {
            'date': date1Ref.current.value,
            'software_name': nameRef.current.value,
            'detail': detailRef.current.value,
            'change_date': date2Ref.current.value,
            'changes_made': optionRef.current.value,

        })

        const resp = res.data;
        if(resp.status == true){
            btnRef.current.disabled = false;
            setalertType("success");
            setalertOpen(true);
            setalertmessage(resp.message);
        }
        else{
            btnRef.current.disabled = false;
            setalertType("error");
            setalertOpen(true);
            setalertmessage(resp.message);
        }

    }


  return (
    <div style={{height: '90vh'}}>
       <div className='text-center mt-2 fs-4 fw-bold' style={{color: "#000078" }}>
            Change in Software
        </div>
        <form className ='col-10 card shadow p-3 mx-auto mt-2' onSubmit={(event)=>{submitForm(event)}}>
        <div>
            <div className='mt-2 fw-bold'>
                Date
            </div>
            <div className='mt-2'>
                <input className='form-control' type='date' ref={date1Ref} required />
            </div>
        </div>
        <div>
            <div className='fw-bold mt-2'>
                Name Of Software
            </div>
            <div className='mt-2'>
                <input className='form-control' ref={nameRef} placeholder='Name Of Software' required />
            </div>
        </div>
        <div>
            <div className='fw-bold mt-2'>
                Detail Of Addition / Changes Made
            </div>
            <div className='mt-2'>
                <textarea className='form-control' ref={detailRef} placeholder='Enter Detail Here' required />
            </div>
        </div>
        <div>
            <div className='mt-2 fw-bold'>
                Date Of Addition / Changes
            </div>
            <div className='mt-2'>
                <input className='form-control' type='date' ref={date2Ref} required />
            </div>
        </div>
        <div>
            <div className='mt-2 fw-bold'>
                Changes Made In
            </div>
            <div className='mt-2'>
                <select className='form-select' ref={optionRef}>
                    <option value="">Select</option>
                    <option value="In-House">In-House</option>
                    <option value="Out-Sourced">Out-Sourced</option>
                </select>
            </div>
        </div>
        <Box className="mx-auto mt-1 mb-1" sx={{ width: "98%" }}>
            <Collapse in={alertopen}>
                <Alert
                severity={alertType}
                action={
                    <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                        setalertOpen(false);
                    }}
                    >
                    <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
                sx={{ mb: 2 }}
                >
                {AlertMessage}
                </Alert>
            </Collapse>
        </Box>
        <div className='mt-3'>
            <button className='btn btn-primary' ref={btnRef}  type='submit'>Save</button>
        </div>
        </form>
    </div>
  )
}
